import { Box, Chip } from "@mui/material"
import type { FC } from "react"

interface SupplierCellProps {
  supplier?: string | null
}

export const SupplierCell: FC<SupplierCellProps> = ({ supplier }) => {
  return (
    <Box className='flex items-center'>
      {supplier && (
        <Chip
          label={supplier}
          size='small'
          variant='filled'
          className='rounded-2xl bg-primary-200 text-xs text-gray-900'
        />
      )}
    </Box>
  )
}
